/**
 * Checks if the date format includes time tokens.
 */
export const hasTimeFormat = (dateFormat: string): boolean => {
    return /[HhmsSaAzZxX]/i.test(dateFormat);
};

